<h1 mat-dialog-title>Export excel receiver#</h1>
<div mat-dialog-content>
<h1><b> {{label}}</b></h1>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button (click)="OnSelectLocations(data)" >Export</button>
</div>
